import { render, staticRenderFns } from "./plano.vue?vue&type=template&id=b3634a78&"
import script from "./plano.vue?vue&type=script&lang=js&"
export * from "./plano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports